import React from 'react';
import { pudeucContent } from '../rich-content/pudeuc-complete-content';
import { AutomaticPageBuilder } from '../page-sections/automatic-page-builder';

const PudeucDetailPage = () => {
  return <AutomaticPageBuilder content={pudeucContent} />;
};

export default PudeucDetailPage;
